export default __webpack_public_path__ + "static/media/pets_icon.7c35f93c.svg";